// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"38f5c71d","732":"2b69732f","977":"80161aed"}[chunkId] + ".chunk.js";
};